import { Route, Routes } from "react-router-dom";

// Pages
import { AppRouter, Login, RequestPasswordReset, ResetPassword } from "@pages/";

// Constants
import { CLIENT_ROUTES } from "@constants/";

// Layouts
import { ProtectedRoute, PublicRoute } from "@layouts/";

// Hooks
import { useAuth } from "@hooks/";

const App = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route element={<PublicRoute isAuthenticated={isAuthenticated} />}>
        <Route path={CLIENT_ROUTES.login} element={<Login />} />
        <Route path={CLIENT_ROUTES.requestPasswordReset} element={<RequestPasswordReset />} />
        <Route path={CLIENT_ROUTES.resetPassword} element={<ResetPassword />} />
      </Route>

      <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
        <Route path="/*" element={<AppRouter />} />
      </Route>
    </Routes>
  );
};

export { App };
